module.exports = __webpack_public_path__ + "static/img/Electronics Electrical.b27c347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applications/Electronics Electrical.jpg
// module id = wSCH
// module chunks = 1